// Stats use the application backend, not the Matrix WebSocket gateway.
export function resolveUserStatsWsUrl(
  explicitUrl: string | undefined,
  chatWsUrl: string | undefined,
  apiHost: string | undefined,
  pageOrigin: string,
): string {
  const explicit = explicitUrl?.trim();
  const url = new URL(explicit || chatWsUrl?.trim() || apiHost?.trim() || pageOrigin, pageOrigin);
  if (!explicit) {
    url.pathname = '/ws/user-stats';
    url.search = '';
    url.hash = '';
  }
  if (url.protocol === 'https:') url.protocol = 'wss:';
  if (url.protocol === 'http:') url.protocol = 'ws:';
  return url.toString();
}

export const USER_STATS_WS_URL = resolveUserStatsWsUrl(
  import.meta.env.VITE_USER_STATS_WS_URL,
  import.meta.env.VITE_WS_URL,
  import.meta.env.VITE_API_HOST,
  window.location.origin,
);
